$(function() {
    "use strict";

    var $wrapper = $('.service-order-form__wrapper');
    var $serviceOrderForm = $('.service-order-form');
    var $buttons =  $serviceOrderForm.find('.service-order-form__buttons');
    var $steps = $serviceOrderForm.find('.service-order-form__step');

    var $nextStepButton = $buttons.find('.service-order-form__button_next');
    var $prevStepButton = $buttons.find('.service-order-form__button_prev');
    var $submitButton = $serviceOrderForm.find('.service-order-form__button_submit');

    var $checkRelatedFields = $serviceOrderForm.find('.service-order-form__check-related').filter('select,input[type="radio"],input[type="checkbox"]');

    var classStepHidden = 'service-order-form__step_hidden';
    var classRelatedStepHidden = 'service-order-form__step_related-hidden';
    var classButtonHidden = 'service-order-form__button_hidden';

    var $process = $wrapper.find('.service-order-form__process__filled');

    var $summary = $wrapper.find('.service-order-form__summary');
    var $summaryElements = $summary.find('.service-order-form__summary-element');

    var showStep = function(step, sign) {
        var maxStep = $buttons.data('maxStep');

        if (step > maxStep || step < 1) {
            return false;
        }
        var currentStep = $buttons.data('currentStep');
        updateSummary(currentStep);

        var $stepBlocks = $steps.filter('[data-step="' + step + '"]');
        $steps.addClass(classStepHidden);
        $stepBlocks.removeClass(classStepHidden);
        $buttons.data('currentStep', step);

        if (step == maxStep) {
            $nextStepButton.addClass(classButtonHidden);
            $submitButton.removeClass(classButtonHidden).prop('disabled', false);
        } else {
            $nextStepButton.removeClass(classButtonHidden);
            $submitButton.addClass(classButtonHidden).prop('disabled', true);
        }

        var percent = (step / maxStep) * 100;
        $process.css('width', percent + '%');


        if (step == maxStep) {
            if ('undefined' !== typeof window.Tracker) {
                window.Tracker.pushEvent(
                    {
                        category : $serviceOrderForm.data('tracking-event-category-on-step'),
                        action   : $serviceOrderForm.data('tracking-event-action-on-last-step'),
                        label    : step + ''
                    }
                );
            }
        } else {
            if ('undefined' !== typeof window.Tracker) {
                window.Tracker.pushEvent(
                    {
                        category : $serviceOrderForm.data('tracking-event-category-on-step'),
                        action   : $serviceOrderForm.data('tracking-event-action-on-step'),
                        label    : step + ''
                    }
                );
            }
        }


        if ($stepBlocks.filter(':visible').length == 0) {
            var nextStep = step + sign;
            if (nextStep > maxStep || nextStep < 1) {
                return false;
            } else {
                showStep(nextStep, sign);
            }
        }
    };

    var validateStep = function (step) {
        var $stepBlocks = $steps.filter('[data-step="' + step + '"]:not(.' + classRelatedStepHidden + ')');

        var $requiredFields = $stepBlocks.find('.service-order-form__required');
        var invalidFields = [];
        if ($requiredFields.length) {
            $requiredFields.each(function() {
                var $field = $(this);
                var fieldId = $field.data('fieldId');
                if (!fieldId) {
                    return;
                }
                if ($field.attr('type') == 'checkbox' || $field.attr('type') == 'radio') {
                    var $step = $field.closest($stepBlocks);
                    var name = $field.attr('name');
                    var $allFieldsWithNameChecked = $step.find('[name="' + name + '"]:checked');
                    if (!$allFieldsWithNameChecked.length) {
                        invalidFields.push(fieldId);
                    }
                } else if ($field.hasClass('service-order-form__calendar')) {
                    if ($field.val() == '') {
                        invalidFields.push(fieldId);
                    } else if (!picker.getMoment().isValid()) {
                        invalidFields.push(fieldId);
                    }
                } else {
                    if ($field.val() == '') {
                        invalidFields.push(fieldId);
                    }
                }
            });
        }

        invalidFields = _.uniq(invalidFields);

        return invalidFields;
    };

    var showErrors = function (step, invalidFields) {
        var $stepBlocks = $steps.filter('[data-step="' + step + '"]');
        for (var key in invalidFields) {
            var fieldId = invalidFields[key];
            var $errorBlock = $stepBlocks.find('[data-error-field="' + fieldId + '"]');
            if ($errorBlock.length) {
                $errorBlock.removeClass('error_hidden').text('Заполните поле');
            }
        }
    };

    var hideErrors = function (step) {
        var $stepBlocks = $steps.filter('[data-step="' + step + '"]');
        $stepBlocks.find('[data-error-field]').addClass('error_hidden');
    };

    var getTextValueFromField = function($field, $stepBlocks) {
        var value = '';
        if ($field.val()) {
            if ($field.attr('type') == 'checkbox' || $field.attr('type') == 'radio') {
                if ($field.is(':checked')) {
                    var id = $field.attr('id');
                    var $label = $field.closest($stepBlocks).find('[for="' + id + '"]');
                    if ($label.length) {
                        value = $label.text();
                    }
                }
            } else if ($field.is('select')) {
                var $selected = $field.find(':selected');
                if ($selected.length) {
                    value = $selected.text();
                }
            } else if ($field.hasClass('service-order-form__calendar')) {
                if (picker.getMoment().isValid()) {
                    value = picker.getMoment().format('DD MMMM YYYY');
                }
            } else if ($field.hasClass('city-selector')) {
                if ($field.select2 && $field.select2('data')) {
                    value = $field.select2('data').short ? $field.select2('data').short : $field.select2('data').value;
                }
            } else {
                value = $field.val();
            }
        }
        return value;
    };

    var updateSummary = function(step) {
        var $stepBlocks = $steps.filter('[data-step="' + step + '"]');
        var $fields = $stepBlocks.find('.service-order-form__input-for-summary');
        var summary = {};
        $fields.each(function() {
            var $field = $(this);
            var fieldId = $field.data('fieldId');
            if (!fieldId) {
                return;
            }
            var value = getTextValueFromField($field, $stepBlocks);
            if (typeof summary[fieldId] == 'undefined') {
                summary[fieldId] = '';
            }

            if ($field.data('summaryRelatedField')) {
                var relatedId = $field.data('summaryRelatedField');
                var $relatedField = $stepBlocks.find('[data-field-id="' + relatedId + '"]');
                if ($relatedField.length) {
                    var relatedValue = getTextValueFromField($relatedField, $stepBlocks);
                    if (relatedValue) {
                        value += ' ' + relatedValue;
                    }
                }
            }

            if (value) {
                if (summary[fieldId] && fieldId in summary) {
                    summary[fieldId] += ', ' + value;
                } else {
                    summary[fieldId] = value;
                }
            }
        });

        for (var fieldId in summary) {
            var text = summary[fieldId];
            var $summaryElement = $summaryElements.filter('[data-field-id="' + fieldId + '"]');
            if (text) {
                $summaryElement.find('.service-order-form__summary-element__value').text(text);
                $summaryElement.removeClass('service-order-form__summary-element_hidden');
            } else {
                $summaryElement.addClass('service-order-form__summary-element_hidden');
            }
        }
    };

    $(document).on('change', $checkRelatedFields.selector, function(e) {
        var $field = $(e.target);
        var id = $field.data('fieldId');
        if (!id) {
            return true;
        }

        var $relatedSteps = $steps.filter('[data-parent-field-id="' + id + '"]');
        if (!$relatedSteps.length) {
            return true;
        }

        if ($field.is('select')) {
            $relatedSteps.addClass(classRelatedStepHidden);
        }

        var val = $field.val();
        $relatedSteps = $relatedSteps.filter('[data-parent-field-value="' + val + '"]');

        if (!$relatedSteps.length) {
            return true;
        }

        if ($field.is(':checked')) {
            $relatedSteps.removeClass(classRelatedStepHidden);
        } else {
            $relatedSteps.addClass(classRelatedStepHidden);
        }
    });

    $(document).on('click', $nextStepButton.selector, function (e) {
        e.preventDefault();

        var currentStep = $buttons.data('currentStep');
        var invalidFields = validateStep(currentStep);
        hideErrors(currentStep);
        if (invalidFields.length) {
            showErrors(currentStep, invalidFields);
            return;
        }
        var nextStep = currentStep + 1;

        showStep(nextStep, 1);
    });

    $(document).on('click', $prevStepButton.selector, function (e) {
        e.preventDefault();

        var $button = $(e.target);
        var currentStep = $buttons.data('currentStep');
        var prevStep = currentStep - 1;

        if (prevStep == 0) {
            var zeroStepLink = $button.data('zeroStepLink');
            if (zeroStepLink) {
                document.location = zeroStepLink;
            }
        } else {
            showStep(prevStep, -1);
        }

    });

    $(document).on('click', $submitButton.selector, function (e) {
        e.preventDefault();

        var currentStep = $buttons.data('currentStep');
        var invalidFields = validateStep(currentStep);
        if (invalidFields.length) {
            showErrors(currentStep, invalidFields);
            return;
        }

        $serviceOrderForm.submit();
    });

    var $calendarField = $serviceOrderForm.find('.service-order-form__calendar');
    if ($calendarField.length) {
        var picker = new Pikaday({
            field: $serviceOrderForm.find('.service-order-form__calendar')[0],
            format: 'DD.MM.YYYY',
            minDate: new Date(),
            maxDate: new Date($calendarField.data('maxDate')),
            firstDay: 1,
            i18n: {
                previousMonth : 'Прошлый месяц',
                nextMonth     : 'Следующий месяц',
                months        : ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
                weekdays      : ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
                weekdaysShort : ['Вс','Пн','Вт','Ср','Чт','Пт','Сб']
            }
        });
    }

    var maxStep = $buttons.data('maxStep');
    var currentStep = $buttons.data('currentStep');
    var percent = (currentStep / maxStep) * 100;
    $process.css('width', percent + '%');

    if ($serviceOrderForm.data('tracking-event-category-on-step')) {
        if ('undefined' !== typeof window.Tracker) {
            window.Tracker.pushEvent(
                {
                    category : $serviceOrderForm.data('tracking-event-category-on-step'),
                    action   : $serviceOrderForm.data('tracking-event-action-on-step'),
                    label    : "1"
                }
            );
        }
    }


    if (currentStep > 1) {
        showStep(currentStep, 1);
    }

});